import { render } from "./backButton.vue?vue&type=template&id=6d20e46e&scoped=true"
import script from "./backButton.vue?vue&type=script&lang=js"
export * from "./backButton.vue?vue&type=script&lang=js"

import "./backButton.vue?vue&type=style&index=0&id=6d20e46e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d20e46e"]])

export default __exports__